import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"
import _imports_0 from '../../assets/no-data.png'


const _hoisted_1 = { class: "ma--top-1 sites--container" }
const _hoisted_2 = {
  key: 0,
  class: "loading"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "loading-pulse" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "row ma--bottom-1" }
const _hoisted_6 = { class: "col-xl-12" }
const _hoisted_7 = { class: "card" }
const _hoisted_8 = { class: "card-header justify--flex-end" }
const _hoisted_9 = { class: "dropdown" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-filter btn--icon__prefix" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "btn--name" }, "Filter", -1)
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = { class: "form-field form-field__outline ma-1" }
const _hoisted_14 = { class: "form-field__outline--control" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", {
  for: "city",
  class: "form-field__outline--control__label"
}, "City", -1)
const _hoisted_16 = { class: "form-field form-field__outline ma-1" }
const _hoisted_17 = { class: "form-field__outline--control" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", {
  for: "state",
  class: "form-field__outline--control__label"
}, "State", -1)
const _hoisted_19 = { class: "form-field form-field__outline ma-1" }
const _hoisted_20 = { class: "form-field__outline--control" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", {
  for: "zipcode",
  class: "form-field__outline--control__label"
}, "Zipcode", -1)
const _hoisted_22 = {
  key: 0,
  class: "card-content"
}
const _hoisted_23 = { class: "table table--striped" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text--align-left" }, "Firstname"),
    /*#__PURE__*/_createElementVNode("th", { class: "text--align-left" }, "Lastname"),
    /*#__PURE__*/_createElementVNode("th", { class: "text--align-left" }, "Address"),
    /*#__PURE__*/_createElementVNode("th", { class: "text--align-left" }, "City"),
    /*#__PURE__*/_createElementVNode("th", { class: "text--align-left" }, "State"),
    /*#__PURE__*/_createElementVNode("th", { class: "text--align-right" }, "Zipcode"),
    /*#__PURE__*/_createElementVNode("th", { class: "text--align-left" }, "Marital status"),
    /*#__PURE__*/_createElementVNode("th", { class: "text--align-left" }, "Gender"),
    /*#__PURE__*/_createElementVNode("th", { class: "text--align-left" }, "Children"),
    /*#__PURE__*/_createElementVNode("th", { class: "text--align-right" }, "Income"),
    /*#__PURE__*/_createElementVNode("th", { class: "text--align-right" }, "Age"),
    /*#__PURE__*/_createElementVNode("th", { class: "text--align-left" }, "Language Spoken"),
    /*#__PURE__*/_createElementVNode("th", { class: "text--align-left" }, "Religion")
  ])
], -1)
const _hoisted_25 = { class: "text--align-left" }
const _hoisted_26 = { class: "text--align-left" }
const _hoisted_27 = { class: "text--align-left" }
const _hoisted_28 = { class: "text--align-left" }
const _hoisted_29 = { class: "text--align-left" }
const _hoisted_30 = { class: "text--align-right" }
const _hoisted_31 = { class: "text--align-left" }
const _hoisted_32 = { class: "text--align-left" }
const _hoisted_33 = { class: "text--align-left" }
const _hoisted_34 = { class: "text--align-right" }
const _hoisted_35 = { class: "text--align-right" }
const _hoisted_36 = { class: "text--align-left" }
const _hoisted_37 = { class: "text--align-left" }
const _hoisted_38 = { key: 0 }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("td", { colspan: "13" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "table__body--empty" }, [
    /*#__PURE__*/_createElementVNode("div", null, "No data to display"),
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: "No Data"
    })
  ])
], -1)
const _hoisted_40 = [
  _hoisted_39
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Pagination = _resolveComponent("Pagination")!
  const _directive_outline = _resolveDirective("outline")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.request._loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("button", {
                type: "submit",
                class: "btn btn--secondary__teal",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showFilters = !_ctx.showFilters))
              }, _hoisted_12),
              _createElementVNode("div", {
                class: _normalizeClass(["dropdown-menu dropdown-menu__right", { show: _ctx.showFilters }]),
                style: {"width":"250px"}
              }, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-field__outline--control__input",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.request.city) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.request.city],
                      [_directive_outline]
                    ]),
                    _hoisted_15
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-field__outline--control__input",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.request.state) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.request.state],
                      [_directive_outline]
                    ]),
                    _hoisted_18
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-field__outline--control__input",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.request.zip) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.request.zip],
                      [_directive_outline]
                    ]),
                    _hoisted_21
                  ])
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn--primary ma-1 text--size-1",
                  style: {"width":"90%"},
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.applyFilters && _ctx.applyFilters(...args)))
                }, " Filter ")
              ], 2)
            ])), [
              [_directive_click_outside, _ctx.clickOutSideFilter]
            ])
          ]),
          (!_ctx.request._loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                _createElementVNode("table", _hoisted_23, [
                  _hoisted_24,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.response.data, (item, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("td", _hoisted_25, _toDisplayString(item.firstName), 1),
                        _createElementVNode("td", _hoisted_26, _toDisplayString(item.lastname), 1),
                        _createElementVNode("td", _hoisted_27, _toDisplayString(item.physicalAddress), 1),
                        _createElementVNode("td", _hoisted_28, _toDisplayString(item.city), 1),
                        _createElementVNode("td", _hoisted_29, _toDisplayString(item.state), 1),
                        _createElementVNode("td", _hoisted_30, _toDisplayString(item.zip), 1),
                        _createElementVNode("td", _hoisted_31, _toDisplayString(item.maritalStatus), 1),
                        _createElementVNode("td", _hoisted_32, _toDisplayString(item.gender), 1),
                        _createElementVNode("td", _hoisted_33, _toDisplayString(item.childrenPresent), 1),
                        _createElementVNode("td", _hoisted_34, _toDisplayString(item.income), 1),
                        _createElementVNode("td", _hoisted_35, _toDisplayString(item.age), 1),
                        _createElementVNode("td", _hoisted_36, _toDisplayString(item.languageSpoken), 1),
                        _createElementVNode("td", _hoisted_37, _toDisplayString(item.religion), 1)
                      ]))
                    }), 128)),
                    (_ctx.response.data.length == 0)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_38, _hoisted_40))
                      : _createCommentVNode("", true)
                  ])
                ]),
                (_ctx.response)
                  ? (_openBlock(), _createBlock(_component_Pagination, {
                      key: 0,
                      totalResults: _ctx.response.pageInfo.totalResults,
                      totalPages: _ctx.response.pageInfo.totalPages,
                      showPage: _ctx.response.data.length,
                      onApplyPagination: _ctx.controlWithPagination
                    }, null, 8, ["totalResults", "totalPages", "showPage", "onApplyPagination"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}